import { useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export default function PaymentMethod({
  register,
  setValue,
  setCurrentStep,
  currentStep,
}) {
  const [error, setError] = useState(false);
  const [checkboxState, setCheckboxState] = useState({
    CC: false,
    EFT: false,
  });
  const { t } = useTranslation();
  const onSubmit = () => {
    if (currentStep <= 4) setCurrentStep(4);
  };

  return (
    <>
      <div className="ui-form-card-no-event">
        <RadioGroup className="ui-form-card-row">
          <RadioGroup.Option
            id="ID_methodStep1Option1"
            className={({ checked }) =>
              `${
                checked && checkboxState.CC
                  ? "ui-form-card selected"
                  : "ui-form-card"
              }  `
            }
            {...register("method")}
            tabIndex="0"
            aria-label="Select to pay this policy"
            aria-controls="ID_methodStep1Option1"
            aria-expanded="false"
            onClick={(e) => {
              setCheckboxState({
                CC: true,
                EFT: false,
              });
              setValue("method", "CC");
              setError(false);
              onSubmit();
            }}
          >
            {({ checked }) => (
              <>
                <RadioGroup.Label
                  className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                  as="p"
                >
                  {t("AgentPaymentMethod-CreditCard")}
                </RadioGroup.Label>

                <div className="text-xxs font-semibold pr-8 group-hover:underline">
                  <div className="ui-form-card-checkbox">
                    <svg
                      className="ui-icon w-2 h-2 text-white hidden"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                </div>
              </>
            )}
          </RadioGroup.Option>
          {/* <RadioGroup.Option
            id="ID_methodStep1Option1"
            className={({ checked }) => `${checked && checkboxState.EFT ? "ui-form-card selected" : "ui-form-card"}`}

            {...register("method")}
            tabIndex="0"
            aria-label="Select EFT"
            aria-controls="ID_methodStep1Option1"
            aria-expanded="false"

            onClick={(e) => {
              setCheckboxState({
                CC: false,
                EFT: true,
              })
              setValue("method", e.target.value)
              setError(true)
              setCurrentStep(3)
            }
            }
          >
            {({ checked }) => (
              <>
                <RadioGroup.Label
                  className="block text-xxs mb-1 pr-8 cursor-pointer font-semibold"
                  as="p"
                >
                  EFT
                </RadioGroup.Label>

                <div className="text-xxs font-semibold pr-8 group-hover:underline">
                  <div className="ui-form-card-checkbox">
                    <svg
                      className="ui-icon w-2 h-2 text-white hidden"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                </div>
                <div id={"method-error"}>
                  {error && (
                    <FormInputError errorMessage={"Please select credit crard"} />
                  )}
                </div>
              </>
            )}
          </RadioGroup.Option> */}
        </RadioGroup>
      </div>
    </>
  );
}
